import React from "react";
import NoDataFoundImg from "../../assets/gobal-search-background.svg";
import noDataFoungImgDark from "../../assets/baseVersion/gobal-search-background-dark.png";
import { useTheme } from "@mui/material";

interface NoDataProps {
  resultAvailable: boolean | null;
  regexSearch: boolean;
  searchText: string;
  invalidRegex: boolean;
  isApiStartedCalling: boolean;
}

const NoData: React.FC<NoDataProps> = ({
  resultAvailable,
  regexSearch,
  searchText,
  invalidRegex,
  isApiStartedCalling,
}) => {
  // Show initial state when search field is empty
  const showInitialState = !regexSearch && searchText.length === 0;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Show "no results" message only when all APIs have finished and no results found
  const showNoResults =
    resultAvailable === false &&
    searchText.length >= 3 &&
    !invalidRegex &&
    !isApiStartedCalling;

  if (!showInitialState && !showNoResults) {
    return null;
  }

  return (
    <div className={`text_center ${showNoResults ? "search-no-results" : ""}`}>
      {showNoResults && <p className="no-data">No search result found</p>}

      {showInitialState && (
        <span className="dark-image-sec">
          <img src= {isDarkMode ? noDataFoungImgDark :NoDataFoundImg} alt="No Data Found" />
        </span>
      )}
    </div>
  );
};

export default NoData;
